export enum LabelNameEnum {
  deals = 'Deals',
  orgs = 'Organizations',
  projects = 'Projects',
  people = 'People',
  contacts = 'Contacts',
  proposals = 'Proposals',
  support = 'Support',
  orders = 'Orders',
  subs = 'Subscriptions',
  reports = 'Reports',
  timeMaterial = 'Time & Materials',
  'tools' = 'Tools',
  'presentations' = 'Presentations',
  subscriptions = 'Subscriptions',
}
export interface CompactLabelResponse {
  name: string;
  value: string;
  status: boolean;
}

export interface LabelResponse {
  labels: CompactLabelResponse[];
}
